import { MouseEventHandler, useState, useEffect } from 'react';
import { useGetString } from '../../../hooks/useGetString';

interface Props {
  className?: string;
  bgColor?: string;
  borderColor?: string;
  textColor?: string;
  text: JSX.Element | string;
  url?: string;
  formTarget?: string;
  color: 'red' | 'redWhite' | 'white' | 'gold' | 'darkGold' | 'grey';
  type?: 'submit' | 'reset' | 'button';
  onClick?: MouseEventHandler;
  disabled?: boolean;
  loading?: boolean;
  dataTestId?: string;
  'aria-describedby'?: string;
  id?: string;
}

export const disabledClasses = 'saturate-75 brightness-50';

const buttonClasses = `min-w-[200px] border border-solid p-2 px-4 rounded-full block text-center min-h-[40px] leading-[20px] text-xl font-bold uppercase w-full focus:outline-none focus-visible:ring-2 focus-visible:ring-darkGold focus-visible:ring-offset-2`;

export default function Button({
  className,
  bgColor,
  borderColor,
  textColor,
  text,
  url,
  formTarget,
  color,
  type,
  disabled,
  onClick,
  loading,
  dataTestId,
  'aria-describedby': ariaDescribedBy,
  id,
}: Props) {
  if (color === 'red') {
    bgColor = 'bg-redFour';
    borderColor = 'border-darkGold';
    textColor = 'text-darkGold';
  }
  if (color === 'redWhite') {
    bgColor = 'bg-redThree';
    borderColor = 'border-redThree';
    textColor = 'text-white';
  }
  if (color === 'white') {
    bgColor = 'bg-white';
    borderColor = 'border-white';
    textColor = 'text-black';
  }
  if (color === 'gold') {
    bgColor = 'bg-darkerGold';
    borderColor = 'border-darkerGold';
    textColor = 'text-white';
  }
  if (color === 'darkGold') {
    borderColor = 'border-darkGold';
    textColor = 'text-darkGold';
  }
  if (color === 'grey') {
    bgColor = 'bg-white';
    textColor = 'text-slate-400';
  }
  const colorClasses = `${bgColor} ${textColor} ${borderColor}`;

  const [isLoading, setLoading] = useState(false);

  const getString = useGetString();
  const loadingString = getString('button.loading');

  useEffect(() => {
    setLoading(!!loading);
  }, [loading]);

  return (
    <>
      {url ? (
        <button
          data-testid={dataTestId || ''}
          id={id}
          disabled={isLoading || disabled}
          // onClick={handleClick}
          formAction={url}
          formTarget={formTarget}
          type={type}
          aria-describedby={ariaDescribedBy}
          className={`transition-filter font-[700] ${
            disabled ? disabledClasses : ''
          } ${colorClasses} ${buttonClasses} ${className}`}
        >
          {isLoading ? loadingString : text}
        </button>
      ) : (
        <button
          data-testid={dataTestId || ''}
          id={id}
          onClick={onClick}
          disabled={isLoading || disabled}
          type={type || 'button'}
          aria-describedby={ariaDescribedBy}
          className={`transition-filter font-[700] ${
            disabled ? disabledClasses : ''
          } ${colorClasses} ${buttonClasses} ${className}`}
        >
          {isLoading ? loadingString : text}
        </button>
      )}
    </>
  );
}
